export const categories = [
  {
    slug: "mingxing-bagua",
    name: "明星八卦",
    description: "最新明星动态、恋情曝光、生活日常",
    icon: "ri-star-line",
  },
  {
    slug: "yingshi-chigua",
    name: "影视吃瓜",
    description: "影视剧内幕、剧组花絮、选角风波",
    icon: "ri-movie-2-line",
  },
  {
    slug: "wanghong-baoliao",
    name: "网红爆料",
    description: "网红圈热点事件、直播翻车、人设崩塌",
    icon: "ri-live-line",
  },
  {
    slug: "quanwei-jiedu",
    name: "圈内解读",
    description: "深度分析、行业揭秘、内幕追踪",
    icon: "ri-search-eye-line",
  },
  {
    slug: "reshi-zhui",
    name: "热搜追击",
    description: "实时追踪各大平台热搜话题与争议",
    icon: "ri-fire-line",
  },
  {
    slug: "bagua-shendu",
    name: "八卦深度",
    description: "长篇深度报道、人物专题、事件始末",
    icon: "ri-file-text-line",
  },
];

export const articles = [
  {
    id: 1,
    slug: "dingliu-nanxing-shenye-yuehui",
    title: "顶流男星深夜密会神秘女子，疑似新恋情曝光",
    excerpt: "近日有媒体拍到某顶流男星深夜与一名神秘女子共同出入高档酒店，两人举止亲密，引发网友热议。据知情人士透露，两人已交往数月。",
    content: "近日，有媒体拍到当红顶流男星李某某深夜与一名神秘女子共同出入某五星级酒店。据目击者称，两人全程举止亲密，李某某更是多次为女方整理衣物，体贴入微。\n\n据圈内知情人士透露，该神秘女子是一名圈外人士，从事金融行业，两人经由共同朋友介绍认识，目前已交往超过三个月。该女子外形出众、家境优渥，与李某某十分般配。\n\n消息一出，迅速登上各大社交平台热搜榜首。粉丝们态度两极分化，一部分人送上祝福，认为偶像到了该谈恋爱的年纪；另一部分则表示难以接受，在社交平台情绪激动。\n\n截至目前，李某某工作室尚未对此事做出正式回应。我们将持续关注事件进展。",
    category: "mingxing-bagua",
    image: "https://readdy.ai/api/search-image?query=Dimly%20lit%20luxury%20hotel%20entrance%20at%20night%20with%20a%20couple%20walking%20together%20in%20elegant%20attire%2C%20warm%20golden%20lighting%20from%20lobby%20spilling%20onto%20street%2C%20paparazzi%20style%20long%20lens%20photography%20with%20shallow%20depth%20of%20field%2C%20cinematic%20noir%20aesthetic%20with%20rich%20amber%20and%20deep%20shadow%20tones%2C%20editorial%20celebrity%20news%20photography%20style&width=800&height=500&seq=article-celebrity-date&orientation=landscape",
    date: "2026-07-06",
    views: 1250000,
    tags: ["恋情曝光", "顶流", "深夜约会"],
    isHot: true,
  },
  {
    id: 2,
    slug: "zhenzhu-xuan-jiang-jin-heimu",
    title: "重磅！某选秀节目被曝内部黑幕，冠军早已内定",
    excerpt: "一位自称节目组前工作人员的网友发长文爆料，称某大型选秀节目的冠军早在录制前就已内定，引发全网哗然。",
    content: "一位自称曾在某大型选秀节目组工作的网友在社交平台发布长文，详细揭露了节目录制过程中的种种内幕。据该网友爆料，节目组在选手海选阶段就已经确定了最终的前三名名单，后续的赛制安排和剪辑都围绕这一预设结果展开。\n\n该网友称，有选手因为拒绝签约节目方指定的经纪公司，即便实力出众也在早期被淘汰；而另一些实力平平的选手，因为签约了关联公司而被一路保送到决赛。\n\n爆料中还提到，节目中的\"观众投票\"环节存在严重数据造假，后台可以随意调整票数比例，所谓的\"公平竞争\"完全是一场精心策划的表演。\n\n此文一经发布，立即在网络上引起轩然大波。节目组官方账号火速发布声明，称该网友所述内容纯属造谣，将保留追究法律责任的权利。",
    category: "yingshi-chigua",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20stage%20lighting%20on%20an%20empty%20talent%20show%20set%20with%20spotlights%20creating%20dramatic%20shadows%2C%20judges%20panel%20in%20silhouette%2C%20cinematic%20theater%20atmosphere%20with%20deep%20red%20and%20gold%20color%20tones%2C%20editorial%20documentary%20style%2C%20mysterious%20and%20investigative%20mood&width=800&height=500&seq=article-talent-show&orientation=landscape",
    date: "2026-07-05",
    views: 980000,
    tags: ["选秀黑幕", "内定", "数据造假"],
    isHot: true,
  },
  {
    id: 3,
    slug: "zhibo-daihuo-fanche-jingcai",
    title: "千万粉丝网红直播带货翻车，被当场打假产品成分",
    excerpt: "拥有三千万粉丝的头部网红在直播间带货某美妆产品时，被职业打假人当场质疑成分表造假，场面一度十分尴尬。",
    content: "昨晚，拥有三千万粉丝的头部网红\"小美酱\"在直播间带货一款宣称\"纯天然有机\"的美妆产品时，遭遇了职业生涯最尴尬的一幕。一位职业打假人通过连麦功能当场指出，该产品的成分表中含有多种化学合成物质，与其宣称的\"纯天然\"严重不符。\n\n该打假人更是现场拿出第三方检测报告，显示产品中含有未在成分表中标注的防腐剂和香精，其中部分成分可能对敏感肌肤造成刺激。面对突如其来的质疑，小美酱一度语塞，只能反复强调\"产品都是经过正规检测的\"。\n\n事件发生后，该产品品牌方紧急下架了所有相关商品链接。多地市场监管部门表示已关注此事，将展开调查。小美酱在今日凌晨发布道歉视频，称自己选品把关不严，将全面复盘合作品牌。",
    category: "wanghong-baoliao",
    image: "https://readdy.ai/api/search-image?query=Modern%20livestreaming%20studio%20setup%20with%20ring%20light%20and%20beauty%20products%20displayed%20on%20desk%2C%20smartphone%20showing%20live%20streaming%20interface%2C%20warm%20soft%20lighting%2C%20editorial%20product%20photography%20with%20slight%20chaotic%20atmosphere%2C%20warm%20neutral%20tones%20with%20pink%20accents%2C%20documentary%20lifestyle%20aesthetic&width=800&height=500&seq=article-livestream-fail&orientation=landscape",
    date: "2026-07-04",
    views: 1560000,
    tags: ["直播翻车", "打假", "网红带货"],
    isHot: true,
  },
  {
    id: 4,
    slug: "guonei-yixian-huadan-pianchou",
    title: "揭秘：国内一线花旦真实片酬曝光，数字令人咋舌",
    excerpt: "一份据称来自某影视公司的内部文件在网络上流传，披露了多位一线女演员的真实片酬，引发对行业薪酬体系的讨论。",
    content: "近日，一份据称来自某头部影视制作公司的内部文件在社交平台上广泛流传。该文件详细列出了多位国内一线女演员近年来的项目片酬，数字之高令人咋舌。\n\n根据文件显示，排名前三的女演员单片片酬均超过八位数，其中最高的一位甚至达到了一部戏近亿元的报价。文件还披露了部分演员的\"隐形收入\"，包括代言分成、投资份额等额外收益。\n\n业内人士分析认为，虽然近年相关部门出台了\"限薪令\"，但顶级演员的收入水平依然远超普通从业者。有评论指出，过高的演员片酬严重挤压了制作预算，导致许多影视剧在剧本、特效等关键环节上捉襟见肘。\n\n该文件的真实性尚未得到官方证实，多家涉及的艺人工作室均拒绝回应。",
    category: "quanwei-jiedu",
    image: "https://readdy.ai/api/search-image?query=Luxurious%20movie%20set%20trailer%20interior%20with%20vanity%20mirror%20surrounded%20by%20warm%20dressing%20room%20lights%2C%20elegant%20costumes%20hanging%20on%20rack%2C%20makeup%20brushes%20and%20cosmetics%20scattered%20on%20table%2C%20soft%20glamorous%20lighting%20with%20warm%20golden%20and%20rose%20tones%2C%20editorial%20behind%20the%20scenes%20film%20industry%20photography&width=800&height=500&seq=article-actress-salary&orientation=landscape",
    date: "2026-07-03",
    views: 890000,
    tags: ["片酬曝光", "一线花旦", "行业揭秘"],
    isHot: false,
  },
  {
    id: 5,
    slug: "resou-diyi-lianxu-ba-qi",
    title: "热搜第一连续霸榜！某明星离婚内幕持续发酵",
    excerpt: "某知名明星夫妇离婚事件持续占据热搜榜首，更多内幕细节陆续浮出水面，双方粉丝在网络上掀起论战。",
    content: "自上周某知名明星夫妇官宣离婚以来，相关话题已连续霸占各大社交平台热搜榜首长达五天。随着越来越多的\"知情人士\"站出来爆料，离婚背后的故事逐渐清晰。\n\n据多位自称与当事人关系密切的人士透露，两人的婚姻早在两年前就已出现裂痕。矛盾的根源在于双方事业发展方向的分歧，以及家庭与工作难以平衡的长期积怨。此外，财产分割问题也成为离婚谈判中的焦点，据悉涉及的共同财产高达数亿元。\n\n双方粉丝在网络上各执一词，互相指责对方偶像在婚姻中的不当行为，形成了一场规模空前的\"粉丝互撕\"。多家主流媒体已就此事发表评论文章，呼吁公众理性看待明星私生活。",
    category: "reshi-zhui",
    image: "https://readdy.ai/api/search-image?query=Split%20screen%20artistic%20composition%20showing%20two%20separate%20elegant%20apartments%20with%20different%20interior%20styles%2C%20one%20minimalist%20and%20cold%2C%20one%20warm%20and%20cozy%2C%20dramatic%20contrast%20lighting%2C%20editorial%20storytelling%20photography%2C%20warm%20and%20cool%20tone%20contrast%2C%20emotional%20and%20atmospheric&width=800&height=500&seq=article-divorce-drama&orientation=landscape",
    date: "2026-07-02",
    views: 2100000,
    tags: ["离婚", "热搜第一", "明星婚姻"],
    isHot: true,
  },
  {
    id: 6,
    slug: "moushi-dianying-bokuan-beizhi",
    title: "深度：某史诗级电影被曝预算严重超支，导演与制片方矛盾激化",
    excerpt: "一部筹备多年的史诗级电影项目近日被曝出预算严重超支，导演与制片方之间的矛盾已公开化，项目前景堪忧。",
    content: "一部筹备长达五年之久的史诗级电影项目，近日因预算问题陷入危机。据多位剧组内部人士透露，该片实际花费已超出原定预算近三倍，导演坚持的艺术追求与制片方的成本控制之间产生了不可调和的矛盾。\n\n据悉，导演在拍摄过程中多次临时增加大场面镜头，单场戏的群演人数从原定的五百人增加到三千人，导致单日拍摄成本飙升。此外，导演对后期特效的要求也远超原计划，特效镜头数量增加了近一倍。\n\n制片方已多次向导演发出书面警告，但收效甚微。目前项目已停工两周，投资方正在评估是否继续追加投资。如果项目最终流产，前期投入的数亿元将面临巨大损失。",
    category: "bagua-shendu",
    image: "https://readdy.ai/api/search-image?query=Empty%20massive%20film%20set%20with%20elaborate%20historical%20set%20design%20in%20shadows%2C%20unattended%20camera%20equipment%20on%20crane%2C%20dust%20particles%20floating%20in%20shaft%20of%20light%2C%20abandoned%20movie%20production%20atmosphere%2C%20dramatic%20chiaroscuro%20lighting%2C%20cinematic%20wide%20angle%2C%20warm%20amber%20and%20deep%20shadow%20tones&width=800&height=500&seq=article-movie-crisis&orientation=landscape",
    date: "2026-07-01",
    views: 670000,
    tags: ["电影超支", "导演矛盾", "深度报道"],
    isHot: false,
  },
  {
    id: 7,
    slug: "xinren-ouxiang-lianai-baoguang",
    title: "新晋偶像团体成员恋情曝光，经纪公司火速发声明",
    excerpt: "狗仔拍到某新晋偶像团体人气成员与圈外女友甜蜜约会，照片曝光后经纪公司火速发布官方声明。",
    content: "知名娱乐狗仔昨日发布了多张偷拍照片，画面中某新晋偶像团体的人气成员与一名年轻女子在某商场甜蜜逛街，两人手牵手，不时亲密交谈，最后共同乘车离开。\n\n照片中的男主角为今年刚出道的新人偶像组合成员，凭借出色的舞台表现和阳光外形迅速积累了大量粉丝。而女方据传是其大学时期的同学，目前在一家互联网公司工作。\n\n照片曝光后，该成员的经纪公司在三小时内火速发布官方声明，称\"目前两人只是普通朋友关系\"，并呼吁粉丝和媒体给予艺人更多私人空间。然而，这样的回应并未平息粉丝的不满，不少粉丝在评论区表达了失望和愤怒。",
    category: "mingxing-bagua",
    image: "https://readdy.ai/api/search-image?query=Young%20couple%20walking%20through%20modern%20shopping%20mall%20with%20warm%20ambient%20lighting%2C%20casual%20street%20style%20fashion%2C%20candid%20moment%20captured%20from%20distance%20with%20telephoto%20lens%20effect%2C%20soft%20bokeh%20background%20with%20storefront%20lights%2C%20warm%20neutral%20and%20golden%20tone%20palette%2C%20editorial%20paparazzi%20style&width=800&height=500&seq=article-idol-dating&orientation=landscape",
    date: "2026-06-30",
    views: 780000,
    tags: ["偶像恋爱", "恋情曝光", "狗仔偷拍"],
    isHot: false,
  },
  {
    id: 8,
    slug: "zongyi-jie-mu-jiemu-zu-neimu",
    title: "综艺节目录制现场惊现\"剧本门\"，嘉宾当场翻脸离场",
    excerpt: "某热门综艺节目录制现场发生意外，一位嘉宾发现节目组预先安排的\"剧本\"后当场翻脸，录制被迫中断。",
    content: "据现场观众爆料，某热门真人秀综艺在最新一期录制过程中发生了意外状况。一位以\"真性情\"著称的嘉宾在录制中途发现，节目组为其精心设计了一个\"冲突剧本\"，要求他在特定环节与其他嘉宾发生争执，以制造节目效果。\n\n该嘉宾对此表示强烈不满，认为这与节目宣称的\"真实记录\"理念严重背离。在现场交涉无果后，这位嘉宾选择当场摘下麦克风离开录制现场，导致录制工作被迫中断近两个小时。\n\n事后，节目组紧急与嘉宾团队进行沟通协调，最终该嘉宾同意继续完成录制，但要求删除所有\"剧本化\"的内容。此事件被现场观众拍摄并发布到网上后，引发了对综艺节目\"真实性\"的广泛讨论。",
    category: "yingshi-chigua",
    image: "https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20bright%20stage%20lights%20and%20cameras%2C%20empty%20guest%20seats%20in%20foreground%2C%20production%20crew%20in%20shadows%20behind%20equipment%2C%20dramatic%20tension%20in%20atmosphere%2C%20warm%20studio%20lighting%20mixing%20with%20cool%20shadow%20areas%2C%20behind%20the%20scenes%20television%20production%20photography&width=800&height=500&seq=article-variety-show&orientation=landscape",
    date: "2026-06-29",
    views: 1100000,
    tags: ["综艺剧本", "现场翻脸", "录制事故"],
    isHot: true,
  },
  {
    id: 9,
    slug: "duan-shipin-pingtai-geju-fenxi",
    title: "深度分析：短视频平台三足鼎立，谁在暗中布局下一个风口",
    excerpt: "随着短视频行业进入存量竞争时代，三大平台纷纷暗中布局新赛道。本文深度分析当前格局与未来趋势。",
    content: "短视频行业经历了野蛮生长的黄金期后，已全面进入存量竞争阶段。目前，三大头部平台形成了相对稳定的\"三足鼎立\"格局。然而，表面的平静之下暗流涌动，各家都在为下一个风口做着紧锣密鼓的布局。\n\n据行业分析报告显示，A平台正在加大对AI生成内容的投入，试图通过技术手段降低内容生产成本；B平台则将目光投向了海外市场，已在东南亚地区取得了显著的用户增长；C平台选择了差异化路线，深耕垂直领域如知识付费和电商直播。\n\n业内人士预测，未来两年内短视频行业的竞争焦点将从\"用户增长\"转向\"用户价值深度挖掘\"。谁能率先找到可持续的商业模式，谁就能在下一轮洗牌中胜出。",
    category: "bagua-shendu",
    image: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20colorful%20social%20media%20app%20interface%20with%20video%20content%2C%20placed%20on%20minimalist%20desk%20with%20warm%20ambient%20lighting%2C%20reflection%20of%20screen%20on%20glossy%20surface%2C%20editorial%20tech%20lifestyle%20photography%2C%20warm%20neutral%20and%20soft%20blue%20screen%20glow%20contrast&width=800&height=500&seq=article-short-video&orientation=landscape",
    date: "2026-06-28",
    views: 450000,
    tags: ["短视频", "行业分析", "深度报道"],
    isHot: false,
  },
  {
    id: 10,
    slug: "yule-quan-nianzhong-pandian",
    title: "2026上半年娱乐圈十大事件盘点，每一件都让人难忘",
    excerpt: "2026年已经过半，娱乐圈发生了太多令人瞠目结舌的事件。让我们一起回顾上半年最令人难忘的十大娱乐事件。",
    content: "2026年上半年，娱乐圈可谓风起云涌，大事件一个接一个。从顶流明星的感情变动到选秀节目的内幕曝光，从网红直播的连环翻车到影视行业的深刻变革，这半年给我们留下了太多讨论的话题。\n\n本文将为大家盘点上半年最具话题度的十大娱乐事件，包括：某影帝婚变事件、三大选秀节目数据造假风波、头部主播集体翻车潮、某国际电影节中国作品斩获大奖、多位老牌艺人宣布复出、某经纪公司被曝虐待练习生、年度爆款网剧背后的资本故事、明星公益造假风波、某综艺导演与嘉宾公开互撕、以及娱乐圈\"限籍令\"新规出台。\n\n每一个事件的背后，都折射出娱乐圈正在经历的深刻变化。",
    category: "reshi-zhui",
    image: "https://readdy.ai/api/search-image?query=Artistic%20collage%20style%20composition%20featuring%20newspaper%20clippings%20and%20magazine%20covers%20on%20minimalist%20background%2C%20warm%20vintage%20paper%20texture%2C%20scattered%20photographs%20with%20soft%20shadows%2C%20editorial%20scrapbook%20aesthetic%2C%20warm%20cream%20and%20sepia%20tone%20with%20modern%20typography%20elements&width=800&height=500&seq=article-year-review&orientation=landscape",
    date: "2026-06-27",
    views: 1800000,
    tags: ["年度盘点", "十大事件", "半年回顾"],
    isHot: true,
  },
];

export const testimonials = [
  {
    id: 1,
    name: "娱乐周刊",
    role: "年度最佳资讯平台",
    quote: "黑料入口已经成为我们获取第一手娱乐资讯的首选平台，更新速度快，内容独家性强，是行业内的标杆。",
  },
  {
    id: 2,
    name: "吃瓜群众代表",
    role: "资深用户",
    quote: "自从用了黑料入口，再也不怕错过任何一个大瓜了。每天刷一刷，比看新闻联播还勤快！",
  },
  {
    id: 3,
    name: "自媒体人小李",
    role: "内容创作者",
    quote: "作为内容创作者，黑料入口是我每天的灵感来源。素材丰富、角度新颖，大大提升了我的创作效率。",
  },
];